<template>
  <v-simple-table class="mt-4" dense>
    <template #default>
      <thead class="table-heading">
        <tr>
          <th class="text-center boder-x-none"></th>
          <th class="text-center boder-x-none text-dark text-nowrap">
            <b>Prom. Últ. 6 meses</b>
          </th>
          <th
            v-for="(item, index) in months"
            :key="index"
            class="text-center boder-x-none text-dark"
          >
            <b>{{ item.full_name }}</b>
          </th>
        </tr>
      </thead>

      <tbody class="custom-table-bordered">
        <tr v-if="loading">
          <td colspan="9">
            <v-skeleton-loader type="table-row-divider@9" />
          </td>
        </tr>
        <tr v-for="(row, index) in monthlySummary.items || []" :key="index">
          <td class="table-heading" v-html="row.title"></td>
          <td
            class="table-heading bg-white text-nowrap"
            :colspan="row.key == 'RENGSFAC' ? 7 : 1"
          >
            <template v-if="row.key == 'PORFACPNC'">
              <a
                class="text-muted"
                @click="$emit('onPNCProductsClick', row)"
                v-html="row.avg"
              />
            </template>
            <template v-else-if="row.key == 'FACCGENN'">
              <a
                class="text-black"
                @click="$emit('onGenNProductsClick', row)"
                v-html="row.avg"
              />
            </template>
            <template v-else-if="row.key == 'C_PAGOSIEL'">
              <a
                class="text-black"
                @click="$emit('onIelPaymentClick')"
                v-html="row.avg"
              />
            </template>
            <v-tooltip v-else bottom>
              <template #activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-html="row.avg" />
              </template>
              <span>{{ row.description }} </span>
            </v-tooltip>
          </td>
          <td v-for="(item, index) in row.items" :key="index" class="bg-white">
            <template v-if="row.key == 'C_PAGOSIEL'">
              <a
                class="text-black"
                @click="$emit('onIelPaymentClick', item.monthKey)"
                v-html="item.value"
              />
            </template>
            <template
              v-else-if="row.key == 'RENGLONAJE' && item.monthKey == lastMonth"
            >
              <a
                class="text-black"
                @click="goToAssortment(1, 'facturados')"
                v-html="item.value"
              />
            </template>
            <template
              v-else-if="row.key == 'RENGSFAC' && item.monthKey == lastMonth"
            >
              <a
                class="text-black"
                @click="goToAssortment('sin-facturar')"
                v-html="item.value"
              />
            </template>
            <span
              v-else
              :class="getCellClass(row, item.valueKey, item.monthKey)"
              v-html="item.value"
            />
          </td>
        </tr>
      </tbody>
      <slot name="avg-delivery-rows" />
    </template>
  </v-simple-table>
</template>

<script>
  import numbers from '@/mixins/numbersFormats';
  import { MetaRoles } from '@/core/constants/roleConstants';

  export default {
    name: 'MonthlySummaryTable',
    mixins: [numbers],
    props: {
      monthlySummary: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
      },
      months: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      lastMonth() {
        return this.months[this.months.length - 1].key;
      },
    },
    methods: {
      goToAssortment(type = 0, status = '') {
        let routename = '';
        switch (this.$route.meta.role) {
          case MetaRoles.Seller:
            routename = 'InvoicedAndNotInvoicedSeller';
            break;
          case MetaRoles.Manager:
            routename =
              type === 1
                ? 'RenglonajeByFamilyManager'
                : 'InvoicedAndNotInvoicedManager';
            break;
          case MetaRoles.RegionalManager:
            routename =
              type === 1
                ? 'RenglonajeByFamilyRegional'
                : 'InvoicedAndNotInvoicedRegional';
            break;
          case MetaRoles.Director:
          case MetaRoles.Subdirector:
            routename =
              type === 1
                ? 'RenglonajeByFamilyDirector'
                : 'InvoicedAndNotInvoicedDirector';
            break;
          default:
            routename = 'InvoicedAndNotInvoicedSeller';
            break;
        }
        const params = status ? { status: status } : {};
        this.$router.push({ name: routename, params: params });
      },
      getCellClass(row, value, monthKey) {
        if (row.min === row.max || monthKey === this.lastMonth) return '';
        switch (value) {
          case row.min:
            return 'text-red font-weight-bold';
          case row.max:
            return 'text-success font-weight-bold';
          default:
            return '';
        }
      },
    },
  };
</script>
